import React, { Fragment } from "react";
import _ from "lodash";
import { connect } from "formik";
import num from "numeral";
import { Grid } from "@material-ui/core";
import { TextInput, RadioInput } from "components/Global/FastFormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const SideLabelRadioWithRefInput = ({ label, fieldName, options, placeholder, formik, isDisabled, hasBorder, shouldHideForQuote, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  const val = _.get(formik.values, fieldName);
  const refVal = _.get(formik.values, `${fieldName}Ref`);

  return (
    <LateralField label={label} hasBorder={hasBorder}>
      <>
        <Grid container item spacing={16}>
          <Grid item xs={6}>
            <RadioInput
              fullWidth
              label={label}
              options={options}
              fieldName={fieldName}
              isDisabled={isDisabled}
            />
          </Grid>
          <Grid item xs={6}>
            {
              !isDisabled ?
                (<TextInput fullWidth fieldName={`${fieldName}Ref`} placeholder="Add a reference" {...otherProps}> </TextInput>) :
                (<ViewOnlyDiv placeholder="No reference">{refVal}</ViewOnlyDiv>)
            }
          </Grid>
        </Grid>
      </>
    </LateralField>
  );
};
export default connect(SideLabelRadioWithRefInput);
